import React, { useContext, useEffect, useState } from 'react'
import AppContext from '../../context/AppContext'
import ProductCard from '../ProductCard/ProductCard'
import './ProductList.css';
import getUserData from '../../helpers/getUserData';

function ProductList(props) {
  const { filtredList, isLoading, setIsLoading } = useContext(AppContext);
  const { listIndex, listSize } = props;
  const maxIndex = listIndex * listSize;
  const minIndex = (maxIndex - listSize) > 0 ? maxIndex - listSize : 0;

  const renderList = () => {
    return (
      filtredList ? (
        <section className="product-list">
          {
            filtredList.length < 1 ?
              <h5>Desculpe, não encontrei nenhum produto</h5> :
              (
                filtredList.filter((element) => {
                  const user = getUserData();
                  if (user === undefined || user.role === 'customer') {
                    return element.status === true;
                  } else {
                    return true;
                  }
                })
                .filter((e, index) => minIndex <= index && index < maxIndex)
                .map((product) => (
                  <ProductCard
                    key={product.id}
                    product={product}
                  />
                ))
              )
          }
        </section>
      ) : (
        <p>Loading</p>
      )
    )
  }

  return (
    <main>
      {
        renderList()
      }
    </main>
  )
}

export default ProductList